import { Stack } from "@mui/material"
import Container from "@mui/material/Container"
import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import FeedBackBox from "../components/global/FeedBackBox"
import { URL } from "../config/apis"
import Pagination from "@mui/material/Pagination"
import { useMemo } from "react"
import SkeletonCard from "../components/global/SkeletonCard"
import DealsTable from "../components/tables/DealsTable"

const pageSize = 20

export default function DoneDealsPage() {
  const cash = JSON.parse(sessionStorage.getItem("dealsPage"))

  const [leads, setLeads] = useState([])
  const [err, setErr] = useState(null)
  const [error, setError] = useState(null)
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [show, setShow] = useState(false)

  const [page, setPage] = useState(cash?.page || 1)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const getLeads = async () => {
    setFetching(true)
    try {
      const res = await axios.get(`${URL}/leads/deals?page=${page}`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      setLeads(res.data?.leads)
      setCount(res.data?.count)
      setLoading(false)
      setFetching(false)
    } catch (error) {
      setLoading(false)
      setFetching(false)
      setErr(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    getLeads()

    sessionStorage.setItem("dealsPage", JSON.stringify({ page }))
  }, [page])

  const totalPages = useMemo(() => {
    return Math.ceil(count / pageSize)
  }, [count, pageSize])

  if (loading) {
    return <SkeletonCard />
  }

  return (
    <>
      <Container maxWidth="100%">
        <DealsTable deals={leads} />
        <br />
        {totalPages > 0 && (
          <Stack
            direction={"row"}
            justifyContent="center"
            sx={{ mt: 2 }}
            spacing={2}
          >
            <Pagination
              page={page}
              onChange={handleChangePage}
              count={totalPages}
              showFirstButton
              showLastButton
            />
          </Stack>
        )}
      </Container>
      <FeedBackBox loading={isLoading} show={show} err={error} />
    </>
  )
}
